import route from '../routes'

export const mockPostData = [
  {
    id: 1,
    title: 'Empathy',
    initialPostDate: 'April 2018',
    url: route.posts.empathy,
  },
  {
    id: 2,
    title: "An New Take on iOS' Now Playing",
    initialPostDate: 'April 2018',
    url: '/writing/a-new-take-on-ios-now-playing',
  },
]

export const worksData = [
  {
    id: 1,
    title: 'Erb Connect',
    initialPostDate: 'April 2018',
    url: route.erbConnect,
    published: false,
  },
  {
    id: 2,
    title: 'Maven Pro',
    initialPostDate: 'January 2017',
    url: route.mavenPro,
    published: true,
  },
]



// WEBPACK FOOTER //
// ./src/data/api/post-data.js